import { ValueApi as ValueApiWeb } from "./web";

export const ValueApi = ValueApiWeb;

export const { createValue, createComputedValue } = ValueApi;
